import React from 'react';
import { FieldPathByValue, UseFormReturn } from 'react-hook-form';
import { CardBody, CardHeader, CardTitle } from '@progress/kendo-react-layout';
import SubjectProfileDetailsConfigurationCheckboxList from './checkbox-list';
import Card from '@components-clean/core/card';
import { TextBoxController } from '@components-clean/core/text-box';
import { useTranslation } from '@hooks/index';
import { SubjectProfileDetailsConfigurationFormValues } from './types';

type CheckboxKey = FieldPathByValue<
    Exclude<SubjectProfileDetailsConfigurationFormValues['siteInformation'], null>,
    boolean | null
>;

const checkboxKeys: CheckboxKey[] = [
    'status',
    'country',
    'activeDate',
    'closedDate',
    'monitor',
    'investigatorName',
    'subjectsScreened',
    'subjectsScreenFailed',
    'subjectEnrolled',
    'subjectRandomized',
    'subjectTxStart',
    'subjectTxDisc',
    'subjectsTxComplete',
    'subjectsFUStart',
    'subjectsFUComplete',
    'numberOfAEs',
    'numberOfSAEs',
    'numberOfAESIs',
    'numberOfPDs',
    'numberOfQueriesOpenAll',
];

type Props = {
    control: UseFormReturn<SubjectProfileDetailsConfigurationFormValues>['control'];
    disabled: boolean;
};

const SiteInformationCard = ({ control, disabled }: Props) => {
    const { t } = useTranslation('admin', {
        keyPrefix: 'subjectConfig.subjectProfileDetailsConfig.siteInformation',
    });

    return (
        <Card padding="none" data-testid="subject-profile-details-configuration-site-information">
            <CardHeader>
                <CardTitle>{t('title')}</CardTitle>
            </CardHeader>

            <CardBody>
                <div>
                    <TextBoxController
                        control={control}
                        name="siteInformation.label"
                        required
                        maxLength={50}
                        label={`${t('field.label')}*`}
                        data-testid="checkbox-siteInformation-label"
                        disabled={disabled}
                    />
                </div>

                <SubjectProfileDetailsConfigurationCheckboxList
                    control={control}
                    disabled={disabled}
                    checkboxKeys={checkboxKeys.map((key) => ({
                        key: `siteInformation.${key}`,
                        label: t(`field.${key}`),
                    }))}
                />
            </CardBody>
        </Card>
    );
};

export default SiteInformationCard;
